import * as api from "@/api/williams/scopesOfWork";
import { DEFAULT_CONTRACTOR_FILTERS } from "../../contractors/hooks";
import { getContractors } from "@/api/williams/contractors";
import { getWeldingSpecialists } from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { useQuery, useQueryClient } from "react-query";

export function useScopeOfWork(scopeOfWorkId?: string) {
  const queryClient = useQueryClient();
  const id = scopeOfWorkId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.scopeOfWork.single(id),
    queryFn: async () => {
      const data = await api.getScopeOfWorkById(id);
      await prefetchMenus();
      return transform(data);
    },
  });

  function transform(data: ScopeOfWork) {
    return {
      ...data,
      // Remove time portion so it works with the HTML date input.
      reportDate: data.reportDate.substring(0, 10),
    };
  }

  function prefetchMenus() {
    const queries = [];

    if (!queryClient.getQueryData(queryKeys.user.weldingSpecialists())) {
      queries.push(queryClient.prefetchQuery(queryKeys.user.weldingSpecialists(), getWeldingSpecialists));
    }
    if (!queryClient.getQueryData(queryKeys.contractor.filter(DEFAULT_CONTRACTOR_FILTERS))) {
      queries.push(
        queryClient.prefetchQuery(queryKeys.contractor.filter(DEFAULT_CONTRACTOR_FILTERS), () => {
          return getContractors(DEFAULT_CONTRACTOR_FILTERS);
        })
      );
    }
    return Promise.all(queries);
  }
}
